import React from 'react';
import { Upload } from 'lucide-react';

const PhotoInstructions = () => (
  <div className="bg-[#DE92A9]/5 p-6 rounded-lg border border-[#DE92A9]/20">
    <div className="flex items-start gap-4">
      <Upload className="text-[#DE92A9] flex-shrink-0 mt-1" size={24} />
      <div>
        <h3
          className="text-lg font-medium text-[#2C2C2C] mb-2"
          style={{ fontFamily: '"Playfair Display", serif' }}
        >
          Say Cheese! Let's Talk Photos!
        </h3>
        <p className="text-[#6B4E37] text-sm mb-3">
          We'd love 30 to 40 of your favourite high-res photos, from the "we do" to the dance floor!
        </p>
        <p className="text-[#6B4E37] text-sm mb-3">
          Think: Ceremony • Reception • Décor • Details • Guest moments • Portraits
        </p>
        <p className="text-[#DE92A9] font-medium">
          Email your images or send via WeTransfer to:
          <br />
          <a
            href="mailto:idobridalmagazinemalta@gmail.com"
            className="underline hover:opacity-80"
          >
            idobridalmagazinemalta@gmail.com
          </a>
        </p>
      </div>
    </div>
  </div>
);

export default PhotoInstructions;
